import WidgetAppsPresentation from 'components/WidgetApps/WidgetAppsPresentation'

export default {
  Presentation: WidgetAppsPresentation,
}
